import { IconButton, Menu, MenuItem } from '@mui/material';
import { PERCENTAGE_FORMATTER } from 'common/constants';
import React, { Fragment, useState } from 'react';
import { changeProductMaxPercentage } from 'v3/pages/Products/List/useCases/change-product-max-percentage';
import { ISku } from 'v3/services/interfaces/response';
import { MoreVertIconStyled, PaperPropsStyle } from 'v3/shared/components/Inputs/MenuProductList/styles';
import { ChangePercentageModal } from 'v3/shared/components/Modal/ChangePercentageModal';
import { IUpdateSkuMaxPercentages } from 'v3/shared/components/Modal/ChangePercentageModal/types';

interface MenuProductListProps {
  sku: ISku;
}

export const MenuProductList: React.FC<MenuProductListProps> = ({ sku }) => {
  const [isChangePercentageModalOpen, setIsChangePercentageModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClickMoreVert = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSelectOption = (option: string) => {
    if (option === 'definePercentage') {
      setIsChangePercentageModalOpen(true);
    }
    handleCloseMenu();
  };

  const handleChangeProductMaxPercentage = async (newPercentages: IUpdateSkuMaxPercentages) => {
    const formatPercentage = (value: number) => parseFloat((value / PERCENTAGE_FORMATTER).toFixed(4));

    const { maxPercentage, maxPercentageAccessories, maxPercentageInsurance } = newPercentages;

    await changeProductMaxPercentage(sku.id, {
      maxPercentage: formatPercentage(maxPercentage),
      maxPercentageAccessories: formatPercentage(maxPercentageAccessories),
      maxPercentageInsurance: formatPercentage(maxPercentageInsurance),
    });
  };

  const decimalToPercentage = (value: number) => {
    return parseFloat((value * PERCENTAGE_FORMATTER).toFixed(2));
  };
  return (
    <Fragment>
      <IconButton onClick={handleClickMoreVert}>
        <MoreVertIconStyled />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu} PaperProps={PaperPropsStyle}>
        <MenuItem onClick={() => handleSelectOption('definePercentage')}>Definir percentuais</MenuItem>
      </Menu>

      <ChangePercentageModal
        modal={{
          initialPercentageForSmartphone: decimalToPercentage(sku.maxPercentage),
          initialPercentageForInsurance: decimalToPercentage(sku.maxPercentageInsurance),
          initialPercentageForAccessories: decimalToPercentage(sku.maxPercentageAccessories),
          active: isChangePercentageModalOpen,
          activeButton: true,
          cancelButton: 'Cancelar',
          saveButton: 'Salvar',
        }}
        onClose={() => setIsChangePercentageModalOpen(false)}
        onConfirm={handleChangeProductMaxPercentage}
      />
    </Fragment>
  );
};
